"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Directive, ElementRef, Input, Optional, Renderer2, Self, } from '@angular/core';
import { LayoutAlignDirective as FlexLayoutLayoutAlignDirective, MediaMonitor, } from '@angular/flex-layout';
import { LayoutDirective } from './layout.directive';
var LayoutAlignDirective = (function (_super) {
    __extends(LayoutAlignDirective, _super);
    function LayoutAlignDirective(monitor, elRef, renderer, container) {
        return _super.call(this, monitor, elRef, renderer, container) || this;
    }
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlign", {
        set: function (val) {
            this._cacheInput('align', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlignMobile", {
        set: function (val) {
            this._cacheInput('alignMobile', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlignTablet", {
        set: function (val) {
            this._cacheInput('alignTablet', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlignDesktopSmall", {
        set: function (val) {
            this._cacheInput('alignDesktopSmall', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlignDesktopLarge", {
        set: function (val) {
            this._cacheInput('alignDesktopLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlignDesktopXLarge", {
        set: function (val) {
            this._cacheInput('alignDesktopXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "layoutAlignDesktopXXLarge", {
        set: function (val) {
            this._cacheInput('alignDesktopXXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('flLayoutAlign'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlign", null);
    __decorate([
        Input('flLayoutAlign.mobile'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlignMobile", null);
    __decorate([
        Input('flLayoutAlign.tablet'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlignTablet", null);
    __decorate([
        Input('flLayoutAlign.desktop-small'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlignDesktopSmall", null);
    __decorate([
        Input('flLayoutAlign.desktop-large'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlignDesktopLarge", null);
    __decorate([
        Input('flLayoutAlign.desktop-xlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlignDesktopXLarge", null);
    __decorate([
        Input('flLayoutAlign.desktop-xxlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], LayoutAlignDirective.prototype, "layoutAlignDesktopXXLarge", null);
    LayoutAlignDirective = __decorate([
        Directive({
            selector: "\n    [flLayoutAlign],\n    [flLayoutAlign.mobile],\n    [flLayoutAlign.tablet],\n    [flLayoutAlign.desktop-small],\n    [flLayoutAlign.desktop-large],\n    [flLayoutAlign.desktop-xlarge],\n    [flLayoutAlign.desktop-xxlarge],\n  ",
        }),
        __param(3, Optional()),
        __param(3, Self()),
        __metadata("design:paramtypes", [MediaMonitor,
            ElementRef,
            Renderer2,
            LayoutDirective])
    ], LayoutAlignDirective);
    return LayoutAlignDirective;
}(FlexLayoutLayoutAlignDirective));
export { LayoutAlignDirective };



// WEBPACK FOOTER //
// layout-align.directive.js